<script>
import Modal from '@/components/atoms/Modal'
import InactiveCartItem from '@/components/atoms/InactiveCartItem'
import ButtonLoader from '@/components/atoms/ButtonLoader'

export default {
    name: 'ModalinactiveItems',

    components: { Modal, InactiveCartItem, ButtonLoader },

    props: {
        currency: {
            type: Object,
            default: () => {},
        },
        items: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            loading: false,
            loadingAll: false,
        }
    },
    computed: {
        inactiveItems() {
            return this.items?.filter((item) =>
                this.$cart.inactiveItems.some(
                    (inactiveItem) => this.getId(item.meal) === inactiveItem?.id
                )
            )
        },
    },

    methods: {
        open() {
            this.$refs.InactiveItemModal.openModal()
        },
        close() {
            this.$refs.InactiveItemModal.closeModal()
        },
        async removeItem(meal) {
            try {
                this.loading = meal
                const index = this.items.findIndex((item) => item.meal === meal)
                if (index > -1) this.$cart.removeMeal(index)
                await this.$cart.calculate()
                if (!this.$cart.hasInactiveItem) this.close()
            } finally {
                this.loading = false
            }
        },
        async removeAllItems() {
            try {
                this.loadingAll = true
                this.$cart.removeInactiveMeals()
                await this.$cart.calculate()
                this.close()
            } finally {
                this.loadingAll = false
            }
        },
    },
}
</script>

<template lang="pug">
modal(ref="InactiveItemModal" scroll)
    template(v-slot:header)
        h1.mb-0.text-center.w-100 {{ $t('cart.inactive_items.title') }}
    template(v-slot:body)
        p {{ $t('cart.inactive_items.desc') }}
        .grid.gap-4
            inactive-cart-item(
                v-for="(item, index) in inactiveItems"
                :key="`inactiveCartItem-${item.meal}-${index}`"
                :value="item"
                :currency="currency"
                :loading="loading === item.meal"
                :disabled="loadingAll || (loading && loading !== item.meal)"
                @remove="removeItem(item.meal)")

    template(v-slot:footer)
        button.btn.btn-secondary.btn-block(@click="close" :disabled="loadingAll || !!loading") {{$t('base.close')}}
        button-loader.btn.btn-primary.btn-block(@click="removeAllItems" :loading="loadingAll" :disabled="!!loading") {{$t('base.clear_all')}}
</template>
